import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {fetchHomeCarouselImages} from "../serverAPI";
import arrowImage from "../assets/arrow.png";

const SliderWrapper = styled.div`
  .slick-prev, .slick-next {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 1;
    background: url(${arrowImage}) no-repeat;
    height: 70px;
    width: 45px;
  }

  .slick-prev::before, .slick-next::before {
    content: none;
  }

  .slick-prev {
    left: 25px;
    background-position: 0 0;
  }

  .slick-next {
    right: 25px;
    background-position: 100% 0;
  }

  .slick-slider:hover .slick-prev,
  .slick-slider:hover .slick-next {
    opacity: 1;
    visibility: visible;
  }
`;

const SliderContainer = styled.div`
  background-color: black;
`;

const SliderImage = styled.img`
  width: 691px;
  height: 478px;
  margin: 0 auto;
`;

export default function HomeImageCarousel() {
  const [images, setImages] = useState(["home1.png", "home2.png", "home3.png"]);
  const settings = {
    dots: false, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1, autoplaySpeed: 3000, autoplay: true
  };

  // 이미지 데이터 가져오기
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const imageList = await fetchHomeCarouselImages();
        setImages(imageList); // 상태에 이미지 파일 이름 저장
      } catch (error) {
        console.error("Error fetching carousel images:", error);
      }
    };

    fetchImages();
  }, []);


  return (<SliderWrapper>
    <Slider {...settings}>
      {images.map((image, index) => (<SliderContainer key={index}>
        <SliderImage
          src={`${process.env.REACT_APP_API_URL || "https://mri.kaist.ac.kr:3100"}/home_carousel_image/${image}`}
          alt={`Carousel ${index + 1}`}
        />
      </SliderContainer>))}
    </Slider>
  </SliderWrapper>);
}
